import r from "./v1/fontFaceDefinitions.json.js";
import { fontsMetadata as o } from "../fonts-metadata/index.js";
import e from "./v1/fonts.css.js";
import i from "./v1/wixMadefor.css.js";
import s from "./v1/helvetica.css.js";
import f from "./v1/google.css.js";
const d = r, F = e, g = i, x = f, v = s, w = Object.keys(o).filter((t) => o[t].provider === "wix-madefor");
export {
  d as fontFaceDefinitions,
  F as fontsCssFileUrl,
  x as googleFonts,
  v as helveticaCssUrl,
  w as madeforFontFamilies,
  g as wixMadeforFontsUrl
};
//# sourceMappingURL=index.js.map
